/**
 * Cart Confirmation Redirect - Prevents add to cart on pick-your-plan and pick-your-frequency.
 * Intercepts clicks, stores selection in sessionStorage, redirects to cart confirmation.
 */
(function() {
  const PICK_PLAN_PATH = '/pages/pick-your-plan';
  const PICK_FREQ_PATH = '/pages/pick-your-frequency';
  const CART_CONFIRM_KEY = 'cartConfirmationData';
  const FUNNEL_GRASS_CART_KEY = 'funnelGrassInCartKey';
  const CART_SYNC_TS_KEY = 'cartConfirmationCartSyncTs';

  function isPickPlanOrFrequencyPage() {
    const path = window.location.pathname.replace(/\/$/, '');
    return path === PICK_PLAN_PATH || path === PICK_FREQ_PATH;
  }

  function isAddToCartClick(target) {
    if (!target || !target.closest) return false;
    var el = target;
    var path = window.location.pathname.replace(/\/$/, '');
    // On pick-frequency page: only intercept tray selection clicks, NOT frequency selection clicks.
    // Frequency "Select" is in [data-frequently]; tray "Select" is in [trays]. Let frequency clicks
    // reach Vue so _selectFrequency runs and shows the tray section.
    if (path === PICK_FREQ_PATH) {
      if (el.closest('[data-frequently]') && !el.closest('[trays]') && !el.closest('[data-details-product]')) return false;
      if (el.closest('[data-details-product]') || el.closest('[trays]')) {
        if (el.closest('button') || el.closest('.no-thanks-btn-wrapper')) return true;
      }
    }
    if (el.closest('.no-thanks-btn-wrapper')) return true;
    if (el.closest('button') && el.closest('button').classList.contains('ATCButtonLast')) return true;
    if (el.classList && el.classList.contains('ATCButtonLast')) return true;
    if (el.hasAttribute && (el.hasAttribute('freevariantid') || el.hasAttribute('freeVariantId'))) return true;
    var card = el.closest('.card-plans');
    if (card && card.querySelector('.ATCButtonLast')) return true;
    if (el.closest('[trays]') && el.closest('[trays]').querySelector('.ATCButtonLast')) return true;
    if (el.closest('[data-details-product]') && (el.closest('button') || el.tagName === 'BUTTON')) return true;
    return false;
  }

  function getVariantFromClick(target) {
    var grassVariantId = localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    var trayResolved = resolveTrayVariantFromClick(target);
    if (trayResolved && trayResolved.isNoThanks) {
      return { grassVariantId: grassVariantId, isNoThanks: true };
    }
    if (trayResolved && trayResolved.variantId) {
      return {
        variantId: trayResolved.variantId,
        grassVariantId: grassVariantId,
        isTray: !trayResolved.isFreeTray,
        isFreeTray: trayResolved.isFreeTray
      };
    }
    return { variantId: null, grassVariantId: grassVariantId, isTray: false };
  }

  function readVariantIdFromEl(el) {
    if (!el) return null;
    return el.getAttribute('data-var_id') || el.getAttribute('data-var-id') || el.getAttribute('data-variant-id')
      || el.getAttribute('freevariantid') || el.getAttribute('freeVariantId');
  }

  function resolveTrayVariantFromClick(target) {
    if (!target || !target.closest) return null;
    if (target.closest('.no-thanks-btn-wrapper') || target.closest('.no-thanks-btn')) {
      return { isNoThanks: true };
    }

    var inTraySection = target.closest('[data-details-product]') || target.closest('[trays]');
    if (!inTraySection) return null;

    var btn = target.closest('button');
    var trayCard = target.closest('[trays]');
    var cardPlans = target.closest('.card-plans');
    var variantId = readVariantIdFromEl(btn);

    if (!variantId && btn) {
      var inner = btn.querySelector('[freevariantid], [freeVariantId]');
      variantId = readVariantIdFromEl(inner);
    }
    if (!variantId && trayCard) {
      var trayBtn = trayCard.querySelector('button[silicon_tray_btn], button[silicone_tray_btn], button[data-var_id], button[freevariantid], button[freeVariantId]');
      variantId = readVariantIdFromEl(trayBtn);
    }
    if (!variantId && cardPlans) {
      variantId = readVariantIdFromEl(cardPlans.querySelector('.card-footer[freevariantid], .card-footer[freeVariantId], [freevariantid], [freeVariantId]'));
    }
    if (!variantId && trayCard) {
      var select = trayCard.querySelector('select[name="id"], select[data-productid]');
      if (select && select.options.length) {
        var opt = select.options[select.selectedIndex] || select.options[0];
        variantId = (opt && (opt.getAttribute('data-variant-id') || opt.value)) || null;
      }
    }

    if (!variantId) return null;

    var isFreeTray = false;
    if (btn) {
      if (btn.hasAttribute('silicon_tray_btn') || btn.hasAttribute('silicone_tray_btn') ||
          (btn.getAttribute('data-var_id') && !btn.hasAttribute('freevariantid') && !btn.hasAttribute('freeVariantId'))) {
        isFreeTray = false;
      } else if (btn.hasAttribute('freevariantid') || btn.hasAttribute('freeVariantId')) {
        isFreeTray = true;
      }
    }
    if (!isFreeTray) {
      var priceEl = (trayCard || cardPlans) && (trayCard || cardPlans).querySelector('.discounted-price, .price-contentt p, .price, .display-8');
      if (priceEl) {
        var priceText = priceEl.textContent.toLowerCase();
        if (priceText.indexOf('free') >= 0 && priceText.indexOf('$') < 0) isFreeTray = true;
      }
    }

    return { variantId: variantId, isFreeTray: isFreeTray, isNoThanks: false };
  }

  function getGrassRefFromStorage() {
    var grassVariantId = localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    var sellingPlanId = localStorage.getItem('defaultSellingPlanId') || localStorage.getItem('defaulrSellingPlanId');
    try {
      var d = JSON.parse(sessionStorage.getItem(CART_CONFIRM_KEY) || '{}');
      grassVariantId = grassVariantId || d.grassVariantId;
      sellingPlanId = sellingPlanId || d.sellingPlanId;
    } catch (e) {}
    return { grassVariantId: grassVariantId, sellingPlanId: sellingPlanId };
  }

  function collectAndStoreCartData(variantInfo, event) {
    const target = event.target;
    const btn = target.closest('button') || target;
    const selectedFreq = document.querySelector('#selected_frequency');
    // PYP stores defaulrSellingPlanId (typo) and defaulrVariantID - support both for backward compat
    const sellingPlanId = localStorage.getItem('defaultSellingPlanId') || localStorage.getItem('defaulrSellingPlanId') || (selectedFreq && selectedFreq.getAttribute('value'));
    const grassVariantId = variantInfo.grassVariantId || (selectedFreq && selectedFreq.getAttribute('variant-id')) || localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    let trayVariantId = null;
    let freeVariantId = null;
    if (variantInfo.isNoThanks) {
      trayVariantId = null;
      freeVariantId = null;
    } else if (variantInfo.isFreeTray && variantInfo.variantId) {
      freeVariantId = variantInfo.variantId;
    } else if (variantInfo.isTray && variantInfo.variantId) {
      trayVariantId = variantInfo.variantId;
    } else if (variantInfo.variantId) {
      trayVariantId = variantInfo.variantId;
    } else if (btn) {
      trayVariantId = btn.getAttribute('addontray') || (btn.closest('[addontray]') && btn.closest('[addontray]').getAttribute('addontray'));
      freeVariantId = btn.getAttribute('freevariantid') || btn.getAttribute('freeVariantId')
        || (btn.querySelector('[freevariantid], [freeVariantId]') && (btn.querySelector('[freevariantid], [freeVariantId]').getAttribute('freevariantid') || btn.querySelector('[freevariantid], [freeVariantId]').getAttribute('freeVariantId')));
    }
    if (!grassVariantId && !trayVariantId && !freeVariantId) return false;

    const deliveryFreq = document.querySelector('.deliveryFrequency');
    const freqOption = deliveryFreq && deliveryFreq.options[deliveryFreq.selectedIndex];
    const sellingPlanIdFromSelect = freqOption ? freqOption.value : sellingPlanId;
    // Prefer localStorage (updated when user clicks frequency card), then selected_frequency, then PYP default
    const frequencyText = localStorage.getItem('defaultFrequencyText') || (selectedFreq && (selectedFreq.getAttribute('frequencytext') || selectedFreq.getAttribute('frequencyText'))) || '';

    let productTitle = 'DoggieLawn', productSize = '24" x 48"', productDesc = 'Dogs 30lbs+', trayTitle = 'No Tray';
    let productImage = '', trayImage = '', selectedStage = '';
    try {
      const app = window.app || (window.theme && window.theme.App);
      var hashHandle = (window.location.hash || '').split('#handle=')[1] || '';
      if (app && app.pickYourPlan) {
        const pyp = app.pickYourPlan;
        selectedStage = pyp.selectedStage || hashHandle || '';
        productTitle = (pyp.selectedProduct ? (pyp.selectedProduct.charAt(0).toUpperCase() + pyp.selectedProduct.slice(1)) + ' DoggieLawn' : '') || 'DoggieLawn';
      } else {
        selectedStage = selectedStage || hashHandle;
      }
      const planTitle = document.querySelector('.plan-title');
      if (planTitle) productTitle = planTitle.textContent || productTitle;
      console.log(planTitle, 'planTitleplanTitleplanTitle ');
      
      const selectedTrayEl = document.querySelector('.selected_tray');
      if (selectedTrayEl) trayTitle = selectedTrayEl.textContent || trayTitle;
      const trayCard = btn && btn.closest('[trays]');
      if (trayCard) {
        const h2 = trayCard.querySelector('.card-title h2, h2');
        if (h2) trayTitle = h2.textContent || trayTitle;
        const img = trayCard.querySelector('img');
        if (img) trayImage = img.src || '';
      }
      const productImg = document.querySelector('.card-img img, [data-image-design-slider] img');
      if (productImg) productImage = productImg.src || '';
      const storedCardImage = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('cardImagePYP');
      if (storedCardImage) productImage = storedCardImage;
      const storedCardTitle = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('cardTitlePYP');
      if (storedCardTitle) productTitle = storedCardTitle;
    } catch (e) {}

    const sizeMap = { standard: '24" x 16"', medium: '24" x 20"', large: '24" x 24"', xl: '24" x 48"', xxl: '48" x 48"' };
    const descMap = { standard: 'Dogs under 15lbs', medium: 'Dogs 10-25lbs', large: 'Dogs 20-35lbs', xl: 'Dogs 30lbs+', xxl: 'Dogs 60lbs+' };
    const stage = selectedStage || (productTitle && productTitle.toLowerCase().replace(' doggielawn', '').replace(' ', ''));
    productSize = sizeMap[stage] || '24" x 48"';
    productDesc = descMap[stage] || 'Dogs 30lbs+';

    // Resolve data-product stage: XL/XXL may use group-1/2/3 or doublexl
    function getProductDataEl(stage) {
      if (!stage) return null;
      var el = document.querySelector('[data-product-' + stage + ']');
      if (el) return el;
      if (stage === 'xl') {
        return document.querySelector('[data-product-group-1]') || document.querySelector('[data-product-group-2]') || document.querySelector('[data-product-group-3]');
      }
      if (stage === 'xxl') {
        return document.querySelector('[data-product-doublexl]') || document.querySelector('[data-product-xxl]') || document.querySelector('[data-product-group-1]');
      }
      return null;
    }
    var deliveryFreqSrc = deliveryFreq;
    if (!deliveryFreqSrc || !deliveryFreqSrc.options || deliveryFreqSrc.options.length === 0) {
      var selectHtml = localStorage.getItem('selectHtml');
      if (selectHtml) {
        var tmp = document.createElement('div');
        tmp.innerHTML = selectHtml;
        deliveryFreqSrc = tmp.querySelector('.deliveryFrequency') || tmp.querySelector('select');
      }
    }
    var frequencyOptionsHtml = '';
    var frequencyOptions = [];
    var trayOptions = [];
    try {
      if (deliveryFreqSrc) {
        frequencyOptionsHtml = (deliveryFreq && deliveryFreq.outerHTML) || deliveryFreqSrc.outerHTML || '';
        for (var i = 0; i < deliveryFreqSrc.options.length; i++) {
          var opt = deliveryFreqSrc.options[i];
          var vid = opt.getAttribute('variant-id') || opt.getAttribute('data-variant-id');
          var price = opt.getAttribute('data-price');
          if ((!vid || !price) && selectedStage) {
            var dpEl = getProductDataEl(selectedStage);
            if (dpEl) {
              try {
                var pData = JSON.parse(dpEl.textContent);
                if (pData.variants) {
                  for (var v = 0; v < pData.variants.length; v++) {
                    var vv = pData.variants[v];
                    if (vv.selling_plan_allocations) {
                      for (var s = 0; s < vv.selling_plan_allocations.length; s++) {
                        var sp = vv.selling_plan_allocations[s].selling_plan || vv.selling_plan_allocations[s];
                        var spId = sp && (sp.id || sp.selling_plan_id);
                        if (spId && String(spId) === String(opt.value)) {
                          vid = vv.id;
                          price = vv.price;
                          break;
                        }
                      }
                    }
                    if (vid) break;
                  }
                }
              } catch (e2) {}
            }
          }
          frequencyOptions.push({ sellingPlanId: opt.value, variantId: vid, price: price, text: opt.textContent.trim() });
        }
      }
      document.querySelectorAll('[trays] .card-plans, [data-tray-standard] .card-plans, [data-tray-medium] .card-plans, [data-tray-large] .card-plans, [data-tray-group-1] .card-plans, [data-tray-doublexl] .card-plans').forEach(function(card) {
        var b = card.querySelector('button[data-var_id], button[silicon_tray_btn], button[silicone_tray_btn]');
        if (!b) b = card.querySelector('button[freeVariantId], button[freevariantid]');
        if (!b) b = card.querySelector('[data-var_id], [freeVariantId], [freevariantid]');
        var titleEl = card.querySelector('.card-title h2, h2');
        var priceEl = card.querySelector('.discounted-price, .price-contentt p, .price');
        var price = 0;
        if (priceEl) {
          if (priceEl.textContent.toLowerCase().indexOf('free') >= 0) price = 0;
          else {
            var pt = priceEl.textContent.replace(/[^0-9.]/g, '');
            if (pt) price = Math.round(parseFloat(pt) * 100);
          }
        }
        var vid = b ? (b.getAttribute('data-var_id') || b.getAttribute('freeVariantId') || b.getAttribute('freevariantid')) : null;
        if (vid && titleEl) trayOptions.push({ variantId: vid, title: titleEl.textContent.trim(), price: price });
      });
    } catch (e) {}
    var trayPrice = 0;
    if (trayVariantId && trayOptions.length) {
      for (var tp = 0; tp < trayOptions.length; tp++) {
        if (trayOptions[tp].variantId == trayVariantId) { trayPrice = trayOptions[tp].price; break; }
      }
    } else if (freeVariantId && trayOptions.length) {
      for (var tp = 0; tp < trayOptions.length; tp++) {
        if (trayOptions[tp].variantId == freeVariantId) { trayPrice = trayOptions[tp].price; break; }
      }
    }

    var productPrice = 0;
    if (frequencyOptions.length) {
      for (var fp = 0; fp < frequencyOptions.length; fp++) {
        if (frequencyOptions[fp].sellingPlanId === (sellingPlanIdFromSelect || sellingPlanId) || frequencyOptions[fp].variantId == grassVariantId) {
          productPrice = Number(frequencyOptions[fp].price) || 0;
          break;
        }
      }
    }
    const data = {
      grassVariantId: grassVariantId || undefined,
      sellingPlanId: sellingPlanIdFromSelect || sellingPlanId || undefined,
      trayVariantId: trayVariantId || undefined,
      freeVariantId: freeVariantId || undefined,
      quantity: 1,
      frequencyText: frequencyText,
      frequencyOptionsHtml: frequencyOptionsHtml || undefined,
      frequencyOptions: frequencyOptions.length ? frequencyOptions : undefined,
      trayOptions: trayOptions.length ? trayOptions : undefined,
      productPrice: productPrice || undefined,
      trayPrice: trayPrice || undefined,
      productTitle: productTitle,
      productSize: productSize,
      productDesc: productDesc,
      trayTitle: trayTitle,
      productImage: productImage,
      trayImage: trayImage,
      selectedStage: selectedStage,
      timestamp: Date.now()
    };

    try {
      const existing = sessionStorage.getItem(CART_CONFIRM_KEY);
      const existingData = existing ? JSON.parse(existing) : {};
      const merged = Object.assign({}, existingData, data);
      if (grassVariantId) merged.grassVariantId = grassVariantId;
      if (variantInfo.isNoThanks) {
        merged.trayVariantId = null;
        merged.freeVariantId = null;
      } else {
        if (trayVariantId) merged.trayVariantId = trayVariantId;
        if (freeVariantId) merged.freeVariantId = freeVariantId;
      }
      if (sellingPlanIdFromSelect || sellingPlanId) merged.sellingPlanId = sellingPlanIdFromSelect || sellingPlanId;
      sessionStorage.setItem(CART_CONFIRM_KEY, JSON.stringify(merged));
      return true;
    } catch (e) { return false; }
  }

  function isTrayStepClick(target) {
    var path = window.location.pathname.replace(/\/$/, '');
    if (path !== PICK_FREQ_PATH) return false;
    if (target.closest('.no-thanks-btn-wrapper') || target.closest('.no-thanks-btn')) return true;
    return !!(target.closest('[data-details-product]') || target.closest('[trays]'));
  }

  var trayCartAddInFlight = null;

  function redirectToCartConfirmation(extraTrayId) {
    if (extraTrayId) {
      try { sessionStorage.setItem('additionalTray', extraTrayId); } catch (err) {}
    }
    window.location.href = '?view=cart-confirmation';
  }

  function addTrayProductToCartOnTraySelect(event) {
    var resolved = resolveTrayVariantFromClick(event.target);
    var variantInfo = getVariantFromClick(event.target);

    if (resolved && resolved.isNoThanks) {
      if (collectAndStoreCartData(variantInfo, event)) {
        redirectToCartConfirmation();
      }
      return Promise.resolve();
    }

    if (!resolved || !resolved.variantId) {
      console.warn('[pick-frequency] Could not resolve tray variant from click', event.target);
      return Promise.resolve();
    }

    if (!collectAndStoreCartData(variantInfo, event)) {
      console.warn('[pick-frequency] Failed to store tray selection data');
    }

    if (trayCartAddInFlight) return trayCartAddInFlight;

    var trayVariantId = resolved.variantId;
    var refs = getGrassRefFromStorage();
    var item = { id: Number(trayVariantId), quantity: 1 };
    if (refs.grassVariantId) {
      item.properties = {
        _ref: String(refs.grassVariantId),
        _refSellingID: String(refs.sellingPlanId || '')
      };
      if (resolved.isFreeTray) {
        item.properties._freeTray = 'true';
      } else {
        item.properties._paidTray = 'true';
      }
    }

    trayCartAddInFlight = fetch(shopifyRoute('cart.js'))
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (isVariantInCart(cart, trayVariantId)) {
          return { skipped: true };
        }
        return fetch(shopifyRoute('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function(r) { return r.json(); });
      })
      .then(function(res) {
        if (res && res.skipped) {
          redirectToCartConfirmation(resolved.isFreeTray ? trayVariantId : null);
          return;
        }
        if (res && res.status && res.status >= 400) {
          console.error('[pick-frequency] Tray cart add failed:', res.description || res.message);
          redirectToCartConfirmation();
          return;
        }
        if (res && (res.items || res.variant_id || res.id)) {
          var app = window.app || (window.theme && window.theme.App);
          if (app && typeof app._getCartData === 'function') app._getCartData();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
        redirectToCartConfirmation(resolved.isFreeTray ? trayVariantId : null);
      })
      .catch(function(err) {
        console.error('[pick-frequency] Tray cart add error:', err);
        redirectToCartConfirmation();
      })
      .finally(function() { trayCartAddInFlight = null; });

    return trayCartAddInFlight;
  }

  function handleClick(e) {
    if (!isPickPlanOrFrequencyPage()) return;
    if (!isAddToCartClick(e.target)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (isTrayStepClick(e.target)) {
      addTrayProductToCartOnTraySelect(e);
      return;
    }

    const variantInfo = getVariantFromClick(e.target);
    if (collectAndStoreCartData(variantInfo, e)) {
      var trayNode = e.target.closest && e.target.closest('[freevariantid], [freeVariantId]');
      var freeVid = trayNode
        ? (trayNode.getAttribute('freevariantid') || trayNode.getAttribute('freeVariantId'))
        : (e.target.getAttribute('freevariantid') || e.target.getAttribute('freeVariantId'));
      redirectToCartConfirmation(freeVid || null);
      return;
    }
  }

  function shopifyRoute(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
  }

  var grassCartAddInFlight = null;

  function grassLineKey(variantId, sellingPlanId) {
    return String(variantId) + '|' + String(sellingPlanId || '');
  }

  function getFunnelGrassCartKey() {
    try { return sessionStorage.getItem(FUNNEL_GRASS_CART_KEY) || ''; } catch (e) { return ''; }
  }

  function setFunnelGrassCartKey(key) {
    try {
      sessionStorage.setItem(FUNNEL_GRASS_CART_KEY, key);
    } catch (e) {}
  }

  function clearFunnelGrassCartKey() {
    try {
      sessionStorage.removeItem(FUNNEL_GRASS_CART_KEY);
    } catch (e) {}
  }

  function getItemSellingPlanId(item) {
    if (!item) return null;
    if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      return item.selling_plan_allocation.selling_plan.id;
    }
    return item.selling_plan || null;
  }

  function isGrassInCart(cart, variantId, sellingPlanId) {
    if (!cart || !cart.items || !variantId) return false;
    return cart.items.some(function(item) {
      if (String(item.variant_id) !== String(variantId)) return false;
      if (!sellingPlanId) return true;
      var itemPlan = getItemSellingPlanId(item);
      return itemPlan && String(itemPlan) === String(sellingPlanId);
    });
  }

  function isVariantInCart(cart, variantId) {
    if (!cart || !cart.items || !variantId) return false;
    return cart.items.some(function(item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  function getSelectHtmlOptions() {
    var options = [];
    try {
      var selectHtml = localStorage.getItem('selectHtml');
      if (selectHtml) {
        var tmp = document.createElement('div');
        tmp.innerHTML = selectHtml;
        options = Array.from(tmp.querySelectorAll('option'));
      }
    } catch (e) {}
    if (!options.length) {
      var liveSelect = document.querySelector('.custom-frequency-funnel .deliveryFrequency, [data-frequently] .deliveryFrequency, .deliveryFrequency.select_freq');
      if (liveSelect && liveSelect.options && liveSelect.options.length) {
        options = Array.from(liveSelect.options);
      }
    }
    return options;
  }

  function matchOptionForFrequencyNumber(frequencyNumber, options) {
    if (!frequencyNumber || !options.length) return null;
    var btnNum = String(frequencyNumber).trim();
    var i;
    for (i = 0; i < options.length; i++) {
      var opt = options[i];
      var fq = (opt.getAttribute('frequencyquantity') || '').trim();
      if (fq && fq === btnNum) return opt;
    }
    for (i = 0; i < options.length; i++) {
      var opt2 = options[i];
      var optText = opt2.textContent.toLowerCase();
      var optNumMatch = optText.match(/\d+/);
      if (optNumMatch && optNumMatch[0] === btnNum) return opt2;
    }
    if (btnNum === '1') {
      for (i = 0; i < options.length; i++) {
        var opt3 = options[i];
        var optFreqQty = opt3.getAttribute('frequencyquantity');
        var optText3 = opt3.textContent.toLowerCase();
        var isWeekly = (optFreqQty === '1') || (optText3.indexOf('week') !== -1 && optText3.indexOf('2') === -1 && optText3.indexOf('3') === -1 && optText3.indexOf('4') === -1);
        if (isWeekly) return opt3;
      }
    }
    return null;
  }

  function isDomElement(el) {
    return !!(el && typeof el.getAttribute === 'function' && typeof el.setAttribute === 'function');
  }

  function normalizeToDomElement(el) {
    if (!el) return null;
    if (isDomElement(el)) return el;
    if (el.currentTarget && isDomElement(el.currentTarget)) return el.currentTarget;
    if (el.target && isDomElement(el.target)) return el.target;
    return null;
  }

  function resolveFrequencyButton(el) {
    el = normalizeToDomElement(el);
    if (!el) return null;
    if (el.tagName === 'BUTTON' && (el.id === 'selected_frequency' || (el.classList && el.classList.contains('ATCButtonLast')))) {
      return el;
    }
    if (el.closest) {
      var card = el.closest('[data-frequently] .card-plans');
      if (card) {
        var cardBtn = card.querySelector('button#selected_frequency, button.ATCButtonLast.select-btn, button.select-btn');
        if (cardBtn) return cardBtn;
      }
      var nestedBtn = el.closest('button#selected_frequency, button.ATCButtonLast.select-btn, button.select-btn');
      if (nestedBtn) return nestedBtn;
    }
    return el;
  }

  function ensureFrequencyButtonAttributes(btn) {
    btn = normalizeToDomElement(btn);
    if (!btn) return null;
    var options = getSelectHtmlOptions();
    var freqNum = btn.getAttribute('frequencynumber');
    if ((!btn.getAttribute('value') || !btn.getAttribute('variant-id')) && options.length) {
      var matched = matchOptionForFrequencyNumber(freqNum, options);
      if (matched) {
        btn.setAttribute('value', matched.value);
        btn.setAttribute('frequencyquantity', matched.getAttribute('frequencyquantity') || freqNum || '1');
        btn.setAttribute('frequencytext', matched.textContent.trim());
        var matchedVid = matched.getAttribute('variant-id') || matched.getAttribute('variant');
        if (matchedVid) btn.setAttribute('variant-id', matchedVid);
      }
    }
    if (!btn.getAttribute('variant-id')) {
      var pypVid = localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
      if (pypVid) btn.setAttribute('variant-id', pypVid);
    }
    return btn;
  }

  function resolveGrassVariantId(btn, sellingPlanId) {
    btn = btn && ensureFrequencyButtonAttributes(btn);
    var variantId = btn && btn.getAttribute('variant-id') || localStorage.getItem('defaulrVariantID') || localStorage.getItem('defaultVariantID');
    if (variantId) return variantId;
    var options = getSelectHtmlOptions();
    var i;
    if (sellingPlanId) {
      for (i = 0; i < options.length; i++) {
        if (String(options[i].value) === String(sellingPlanId)) {
          return options[i].getAttribute('variant-id') || options[i].getAttribute('variant');
        }
      }
    }
    try {
      var selectHtml = localStorage.getItem('selectHtml');
      if (selectHtml) {
        var tmp = document.createElement('div');
        tmp.innerHTML = selectHtml;
        var selectEl = tmp.querySelector('.deliveryFrequency');
        if (selectEl && selectEl.getAttribute('variant-id')) return selectEl.getAttribute('variant-id');
      }
      var liveSelect = document.querySelector('.custom-frequency-funnel .deliveryFrequency, .deliveryFrequency.select_freq');
      if (liveSelect && liveSelect.getAttribute('variant-id')) return liveSelect.getAttribute('variant-id');
    } catch (e) {
      return null;
    }
    return null;
  }

  /**
   * Step 2 (pick-frequency): add subscription grass product to Shopify cart
   * when the customer selects a replacement frequency.
   */
  function addGrassProductToCartOnFrequencySelect(el) {
    var btn = ensureFrequencyButtonAttributes(resolveFrequencyButton(el));

    if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return Promise.resolve();

    var sellingPlanId = (btn && btn.getAttribute('value')) || localStorage.getItem('defaultSellingPlanId') || localStorage.getItem('defaulrSellingPlanId');
    var variantId = resolveGrassVariantId(btn, sellingPlanId);

    if (!sellingPlanId && btn && btn.getAttribute('frequencynumber')) {
      var opt = matchOptionForFrequencyNumber(btn.getAttribute('frequencynumber'), getSelectHtmlOptions());
      if (opt) {
        sellingPlanId = opt.value;
        btn.setAttribute('value', opt.value);
        if (!variantId) {
          variantId = opt.getAttribute('variant-id') || opt.getAttribute('variant');
          if (variantId) btn.setAttribute('variant-id', variantId);
        }
      }
    }

    if (!variantId || !sellingPlanId) {
      console.warn('[pick-frequency] Missing variant or selling plan for cart add', {
        variantId: variantId,
        sellingPlanId: sellingPlanId,
        frequencyNumber: btn && btn.getAttribute('frequencynumber')
      });
      return Promise.resolve();
    }

    var dedupeKey = grassLineKey(variantId, sellingPlanId);
    if (grassCartAddInFlight) return grassCartAddInFlight;

    localStorage.setItem('defaulrVariantID', variantId);
    localStorage.setItem('defaultSellingPlanId', sellingPlanId);
    localStorage.setItem('defaulrSellingPlanId', sellingPlanId);
    localStorage.setItem('frequencyQuantity', (btn && btn.getAttribute('frequencyquantity')) || localStorage.getItem('frequencyQuantity') || '');
    localStorage.setItem('defaultFrequencyText', (btn && (btn.getAttribute('frequencytext') || btn.getAttribute('frequencyText'))) || localStorage.getItem('defaultFrequencyText') || '');

    var frequencyText = (btn && (btn.getAttribute('frequencytext') || btn.getAttribute('frequencyText'))) || localStorage.getItem('defaultFrequencyText') || '';

    try {
      var existing = sessionStorage.getItem(CART_CONFIRM_KEY);
      var data = existing ? JSON.parse(existing) : {};
      data.grassVariantId = variantId;
      data.sellingPlanId = sellingPlanId;
      data.frequencyText = frequencyText;
      data.quantity = data.quantity || 1;
      data.timestamp = Date.now();
      sessionStorage.setItem(CART_CONFIRM_KEY, JSON.stringify(data));
    } catch (e) {}

    grassCartAddInFlight = fetch(shopifyRoute('cart.js'))
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (isGrassInCart(cart, variantId, sellingPlanId)) {
          setFunnelGrassCartKey(dedupeKey);
          return { skipped: true };
        }
        if (dedupeKey === getFunnelGrassCartKey()) {
          clearFunnelGrassCartKey();
        }

        var updates = {};
        (cart.items || []).forEach(function(item) {
          if (String(item.variant_id) === String(variantId)) {
            updates[item.key] = 0;
          }
        });
        var removePromise = Object.keys(updates).length
          ? fetch(shopifyRoute('cart/update.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
          : Promise.resolve();
        return removePromise.then(function() {
          return fetch(shopifyRoute('cart/add.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(variantId),
                quantity: 1,
                selling_plan: sellingPlanId
              }]
            })
          });
        }).then(function(r) { return r.json(); });
      })
      .then(function(res) {
        if (res && res.skipped) return;
        if (res && res.status && res.status >= 400) {
          console.error('[pick-frequency] Cart add failed:', res.description || res.message);
          clearFunnelGrassCartKey();
          return;
        }
        if (res && (res.items || res.variant_id || res.id)) {
          setFunnelGrassCartKey(dedupeKey);
          var app = window.app || (window.theme && window.theme.App);
          if (app && typeof app._getCartData === 'function') app._getCartData();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      })
      .catch(function(err) {
        console.error('[pick-frequency] Cart add error:', err);
        clearFunnelGrassCartKey();
      })
      .finally(function() { grassCartAddInFlight = null; });

    return grassCartAddInFlight;
  }

  function buildFunnelItemsToSync(cart, d) {
    if (!d || !d.grassVariantId) return [];
    var items = [];
    if (!isGrassInCart(cart, d.grassVariantId, d.sellingPlanId)) {
      items.push({
        id: d.grassVariantId,
        quantity: d.quantity || 1,
        selling_plan: d.sellingPlanId || null
      });
    }
    if (d.trayVariantId && d.trayVariantId !== 'none' && !isVariantInCart(cart, d.trayVariantId)) {
      items.push({
        id: d.trayVariantId,
        quantity: d.quantity || 1,
        properties: {
          _ref: String(d.grassVariantId),
          _refSellingID: String(d.sellingPlanId || ''),
          _paidTray: 'true'
        }
      });
    } else if (d.freeVariantId && !isVariantInCart(cart, d.freeVariantId)) {
      items.push({
        id: d.freeVariantId,
        quantity: 1,
        properties: {
          _ref: String(d.grassVariantId),
          _refSellingID: String(d.sellingPlanId || ''),
          _freeTray: 'true'
        }
      });
    }
    return items;
  }

  window.addGrassProductToCartOnFrequencySelect = addGrassProductToCartOnFrequencySelect;
  window.addTrayProductToCartOnTraySelect = addTrayProductToCartOnTraySelect;
  window.__funnelCart = {
    grassLineKey: grassLineKey,
    isGrassInCart: isGrassInCart,
    isVariantInCart: isVariantInCart,
    buildFunnelItemsToSync: buildFunnelItemsToSync,
    clearFunnelGrassCartKey: clearFunnelGrassCartKey,
    setFunnelGrassCartKey: setFunnelGrassCartKey,
    getFunnelGrassCartKey: getFunnelGrassCartKey,
    resolveFrequencyButton: resolveFrequencyButton,
    ensureFrequencyButtonAttributes: ensureFrequencyButtonAttributes,
    resolveTrayVariantFromClick: resolveTrayVariantFromClick,
    CART_SYNC_TS_KEY: CART_SYNC_TS_KEY
  };

  function init() {
    if (!isPickPlanOrFrequencyPage()) return;
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

(function () {
  if ((window.location.search || '').indexOf('view=cart-confirmation') === -1) return;

  window.toggleCart = function toggleCart() {
    var app = window.app;
    if (app && typeof app._toggleCartDrawer === 'function') {
      app._toggleCartDrawer();
    }
  };

  document.addEventListener(
    'click',
    function (e) {
      var cartAnchor = e.target && e.target.closest && e.target.closest('.cart-link a');
      if (!cartAnchor) return;
      e.preventDefault();
      e.stopPropagation();
      window.toggleCart();
    },
    true
  );
})();